module.exports = __webpack_public_path__ + "img/refer-a-friend.41b15127.svg";